<div class="body-wrapper" *ngIf="print.loaded" [ngClass]="Direction" style='padding-top: 0;'>
    <header class="header">
        <div class="justify-between items-center" [innerHtml]="altHeader" *ngIf="altHeader && showHeader"></div>
        <div class="justify-between items-center" *ngIf="print.env && print.env['haslogo'] && ! altHeader">
            <img style="width: 100%;" [src]="! print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo">
        </div>
        <div class="justify-between items-center" style="margin-bottom: 5px;">
            <h1 class="header-title" style="width: max-content;font-size: 30px;">
                {{print.exam.Changed ? print.exam.ChangedExamTitle : ('exam.type.genus.Endoscopy' | translate)}}
                <ng-container *ngIf="!print.exam.Changed && subExamType">
                    <span>  {{'endoscopy.' + subExamType | translate}}</span>
                </ng-container>
                <span *ngIf="print.exam?.Draft">
                    <br/>
                    ({{'general.DraftPrint' | translate}})
                </span>
            </h1>
        </div>
        <div class="header-details" style="margin-bottom: 3em;">
            <div style="display: inline-block; padding-left: 1em;padding-right: 1em;font-size: 12pt;">{{(print.isForm ? 'general.date' :'general.ExaminationDate')| translate}}:&nbsp;<strong style='direction: ltr;'>{{print.exam.CreationTime | date:"dd.MM.yyyy"}}</strong></div>
            <div style="display: inline-block;font-size: 12pt">
                {{'general.Printing_Date' | translate}}:&nbsp;
                <strong style='direction: ltr;'>
                    {{now | date:"dd.MM.yyyy HH:mm"}}
                </strong>
            </div>
        </div>
    </header>

    <main class="main" [ngClass]="typeOfPrint">
        <section class="section" *ngIf="print.Pat">
            <h4 class="text-20 text-gold">{{(print.Pat.Sex ? (print.Pat.Sex == 'M' ?  'gastro.Patient.male' : 'gastro.Patient.female'): 'gastro.Patient.details') | translate}}</h4>
            <div style="width:100%">
                <div>
                    <table>
                        <tr>
                            <td>
                                <dt>{{'general.Patient.first_name' | translate}}</dt>
                                <dd>{{print.Pat.First}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.last_name' | translate}}</dt>
                                <dd>{{print.Pat.Last}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.ID' | translate}}</dt>
                                <dd>{{print.Pat.ID}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Mobile">
                                <dt>{{'general.Patient.mobile' | translate}}</dt>
                                <dd>{{print.Pat.Mobile}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Sex">
                                <dt>מגדר</dt>
                                <dd>{{print.Pat.Sex == 'M'? 'גבר': 'אישה' }}</dd>
                            </td>
                        </tr>
                        <tr *ngIf="print.Pat.Height || print.Pat.Weight">
                            <td *ngIf="print.Pat.Birth">
                                <dt>{{'general.Patient.birth_date' | translate}}</dt>
                                <dd>{{print.Pat.Birth| date:"dd.MM.yyyy"}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Birth">
                                <dt>{{'general.Patient.Age' | translate}}</dt>
                                <dd>{{print.Pat.getAgeMo()}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Height">
                                <dt>גובה</dt>
                                <dd>{{print.Pat.Height}}cm</dd>
                            </td>
                            <td *ngIf="print.Pat.Weight">
                                <dt>משקל</dt>
                                <dd>{{print.Pat.Weight}}kg</dd>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </section>

    <ng-container *ngIf="print.usGeneral && print.usGeneral[0]">

        <!-- Preparation section - unified -->
        <section class="section no-page-break"
            *ngIf="print.usGeneral[0].MedicalHistory || print.usGeneral[0].ReasonExamination || print.usGeneral[0].Reasone || print.usGeneral[0].Preparetion || print.usGeneral[0].Comments || (print.Medication && print.Medication.length > 0)">
            <section class="section no-page-break" *ngIf="print.usGeneral[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].MedicalHistory}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].ReasonExamination">
                <h2>{{'GyneIntro.Purpose_of_Exam' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].ReasonExamination}}</div>
            </section>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].Reasone">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].Reasone}}</div>
            </section>
            <div style="display: inline-flex; gap: 3em; margin-top: 0.5em;">
                <span *ngIf="print.usGeneral[0].ASA && print.usGeneral[0].ASA != '-1'">
                    <strong>ASA:</strong> {{print.usGeneral[0].ASA}}
                </span>
                <span *ngIf="print.usGeneral[0].Mellampeti && print.usGeneral[0].Mellampeti != '-1'">
                    <strong>Mallampati:</strong> {{print.usGeneral[0].Mellampeti}}
                </span>
            </div>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].Preparetion">
                <h2>{{'gastro.preparetion.preparetion' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].Preparetion}}</div>
                <div style="display: inline-flex; gap: 2em; margin-top: 0.5em;">
                    <span *ngIf="print.usGeneral[0].BBPS && print.usGeneral[0].BBPS != '-1'">
                        <strong>BBPS:</strong> {{print.usGeneral[0].BBPS}}
                    </span>
                    <span *ngIf="print.usGeneral[0].Quality">
                        <strong>{{'gastro.preparetion.title' | translate}}:</strong>
                        {{'gastro.preparetion.Quality.' + print.usGeneral[0].Quality | translate}}
                    </span>
                </div>
            </section>
          
            <section class="section no-page-break" *ngIf="print.Medication && print.Medication.length > 0">
                <h2>{{'gastro.preparetion.Medication' | translate}}</h2>
                <table>
                    <tr>
                        <td><strong>{{'gastro.preparetion.Medication_type' | translate}}</strong></td>
                        <td><strong>{{'gastro.preparetion.Dose' | translate}}</strong></td>
                        <td><strong>{{'gastro.preparetion.Unit' | translate}}</strong></td>
                    </tr>
                    <tr *ngFor="let m of print.Medication">
                        <td>{{m.Medication}}</td>
                        <td>{{m.Dose}}</td>
                        <td>{{m.Unit}}</td>
                    </tr>
                </table>
            </section>
              <section class="section no-page-break" *ngIf="print.usGeneral[0].Comments">
                <h2>{{'gastro.preparetion.Comments' | translate}}</h2>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].Comments}}</div>
            </section>
        </section>

        <!-- ====== GASTROSCOPY FINDINGS (Gastro / Both) ====== -->
        <ng-container *ngIf="isGastro">
            <section class="section">
                <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate}} — גסטרוסקופיה</h4>

                <section class="section no-page-break" *ngIf="print.usGeneral[0].ExtentOfExam">
                    <h4>{{'gastro.preparetion.ExtentOfExam' | translate}}</h4>
                    <div style="white-space: pre-wrap;">{{print.usGeneral[0].ExtentOfExam}}</div>
                </section>

                <!-- NPD -->
                <section class="section no-page-break" *ngIf="print.usGeneral[0].Gastroscopy == 0">
                    <strong>{{'gastro.Findings.NPD_UpperGastro' | translate}}</strong>
                </section>

                <!-- Pathological Diagnosis -->
                <ng-container *ngIf="print.usGeneral[0].Gastroscopy != 0">
                    <section class="section no-page-break" *ngIf="print.usGeneral[0].Esophagus || print.usGeneral[0].EsophagusComment">
                        <h4>{{'gastro.Findings.Esophagus' | translate}}</h4>
                        <div *ngIf="print.usGeneral[0].Esophagus">
                            <strong>{{(print.usGeneral[0].Esophagus == 'NPD' ? 'gastro.Findings.NPD' : 'gastro.Findings.PD') | translate}}:</strong>
                        </div>
                        <div *ngIf="print.usGeneral[0].EsophagusComment" style="white-space: pre-wrap;">{{print.usGeneral[0].EsophagusComment}}</div>
                    </section>

                    <section class="section no-page-break" *ngIf="print.usGeneral[0].EsoJunction || print.usGeneral[0].EsoJunctionComment">
                        <h4>{{'gastro.Findings.EsoJunction' | translate}}</h4>
                        <div *ngIf="print.usGeneral[0].EsoJunction">
                            <strong>{{(print.usGeneral[0].EsoJunction == 'NPD' ? 'gastro.Findings.NPD' : 'gastro.Findings.PD') | translate}}:</strong>
                        </div>
                        <div *ngIf="print.usGeneral[0].EsoJunctionComment" style="white-space: pre-wrap;">{{print.usGeneral[0].EsoJunctionComment}}</div>
                    </section>

                    <section class="section no-page-break" *ngIf="print.usGeneral[0].Stomach || print.usGeneral[0].StomachComment">
                        <h4>{{'gastro.Findings.Stomach' | translate}}</h4>
                        <div *ngIf="print.usGeneral[0].Stomach">
                            <strong>{{(print.usGeneral[0].Stomach == 'NPD' ? 'gastro.Findings.NPD' : 'gastro.Findings.PD') | translate}}:</strong>
                        </div>
                        <div *ngIf="print.usGeneral[0].StomachComment" style="white-space: pre-wrap;">{{print.usGeneral[0].StomachComment}}</div>
                    </section>

                    <section class="section no-page-break" *ngIf="print.usGeneral[0].Duodenum || print.usGeneral[0].DuodenumComment">
                        <h4>{{'gastro.Findings.Duodenum' | translate}}</h4>
                        <div *ngIf="print.usGeneral[0].Duodenum">
                            <strong>{{(print.usGeneral[0].Duodenum == 'NPD' ? 'gastro.Findings.NPD' : 'gastro.Findings.PD') | translate}}:</strong>
                        </div>
                        <div *ngIf="print.usGeneral[0].DuodenumComment" style="white-space: pre-wrap;">{{print.usGeneral[0].DuodenumComment}}</div>
                    </section>
                </ng-container>

                <section class="section no-page-break" *ngIf="print.usGeneral[0].Hp">
                    <h4>Rapid Urease Test (H.pylori)</h4>
                    <div>{{print.usGeneral[0].Hp === 'positive' ? 'חיובי' : 'שלילי'}}</div>
                    <div *ngIf="print.usGeneral[0].HpComment" style="white-space: pre-wrap;">{{print.usGeneral[0].HpComment}}</div>
                </section>

            </section>
        </ng-container>

        <!-- ====== COLONOSCOPY FINDINGS (Colonoscopy / Both) ====== -->
        <ng-container *ngIf="isColono">
            <section class="section">
                <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate}}<ng-container *ngIf="subExamType !== 'HRA'"> — {{'gastro.Findings.Colonoscopy' | translate}}</ng-container></h4>

                <section class="section no-page-break" *ngIf="print.usGeneral[0].ExtentOfExam && !isGastro">
                    <h4>{{'gastro.preparetion.ExtentOfExam' | translate}}</h4>
                    <div style="white-space: pre-wrap;">{{print.usGeneral[0].ExtentOfExam}}</div>
                </section>

                <!-- NPD -->
                <section class="section no-page-break" *ngIf="print.usGeneral[0].Colonoscopy == 0">
                    <strong>{{'gastro.Findings.NPD_NoDiagnosticFindings' | translate}}</strong>
                    <div *ngIf="print.usGeneral[0].FindingsComment" style="white-space: pre-wrap; margin-top: 0.5em;">
                        {{print.usGeneral[0].FindingsComment}}
                    </div>
                </section>

                <!-- Pathological Diagnosis -->
                <ng-container *ngIf="print.usGeneral[0].Colonoscopy == 1">
                    <section class="section no-page-break" *ngIf="print.usGeneral[0].DetailsFindings && print.usGeneral[0].DetailsFindings.length > 0">
                        <h4>{{'gastro.Findings.PD' | translate}}</h4>
                        <table>
                            <ng-container *ngFor="let f of print.usGeneral[0].DetailsFindings">
                                <tr *ngIf="isMarked(f.value) || f.comment">
                                    <td>{{'gastro.Findings.type.' + f.db | translate}}</td>
                                    <td>{{isMarked(f.value) ? ((f.value == 1 ? 'gastro.Findings.diagnosticFinding' : 'gastro.Findings.normal') | translate) : ''}}</td>
                                    <td>{{f.comment}}</td>
                                </tr>
                            </ng-container>
                        </table>
                    </section>
                </ng-container>

                <section class="section no-page-break" *ngIf="print.usGeneral[0].ColoComment">
                    <h4>{{'gastro.Findings.Comments' | translate}}</h4>
                    <div style="white-space: pre-wrap;">{{print.usGeneral[0].ColoComment}}</div>
                </section>
            </section>
        </ng-container>

        <!-- ====== HRA DIAGRAM (only when something was marked) ====== -->
        <section class="section no-page-break" *ngIf="subExamType === 'HRA' && print.usGeneral[0].HraDiagram">
            <app-hra-diagram [value]="print.usGeneral[0].HraDiagram" [readonly]="true"></app-hra-diagram>
        </section>

        <!-- ====== OTHER ENDOSCOPY FINDINGS ====== -->
        <ng-container *ngIf="isOther">
            <section class="section">
                <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate}}</h4>
                <section class="section no-page-break" *ngIf="print.usGeneral[0].FindingsComment">
                    <div style="white-space: pre-wrap;">{{print.usGeneral[0].FindingsComment}}</div>
                </section>
            </section>
        </ng-container>

        <!-- ====== HRA VIROLOGY ====== -->
        <section class="section no-page-break" *ngIf="subExamType === 'HRA' && print.usGeneral[0].Hp">
            <h4>Virology (וירולוגיה)</h4>
            <div>{{print.usGeneral[0].Hp === 'positive' ? 'חיובי' : 'שלילי'}}</div>
            <div *ngIf="print.usGeneral[0].HpComment" style="white-space: pre-wrap;">{{print.usGeneral[0].HpComment}}</div>
        </section>

        <!-- Pathology -->
        <section class="section no-page-break" *ngIf="(pathologyS.pathologies && pathologyS.pathologies.length > 0) || print.usGeneral[0].PathologyComments">
            <h4 class="text-20 text-gold">{{'gastro.Pathology.title' | translate}}</h4>
            <table *ngIf="pathologyS.pathologies && pathologyS.pathologies.length > 0">
                <tr>
                    <td><strong>#</strong></td>
                    <td><strong>{{'gastro.Pathology.Type' | translate}}</strong></td>
                    <td><strong>ברקוד</strong></td>
                    <td><strong>{{'gastro.preparetion.Comments' | translate}}</strong></td>
                </tr>
                <tr *ngFor="let p of pathologyS.pathologies; index as i">
                    <td>{{i + 1}}</td>
                    <td>{{p.Type}}</td>
                    <td>{{p.BarCode}}</td>
                    <td>{{p.Comments}}</td>
                </tr>
            </table>
            <section class="section no-page-break" *ngIf="print.usGeneral[0].PathologyComments">
                <h4>{{'gastro.Findings.Comments' | translate}}</h4>
                <div style="white-space: pre-wrap;">{{print.usGeneral[0].PathologyComments}}</div>
            </section>
        </section>

        <!-- Diagnosis (GUS-88 catalogue) -->
        <section class="section no-page-break" *ngIf="print.hasExamDiagnoses()">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.examDiagnoses.length">
                <h4>{{ 'examDiagnoses.main' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.diagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.secondaryDiagnoses.length">
                <h4>{{ 'examDiagnoses.secondary' | translate }}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.secondaryDiagnosesText() }}</div>
            </ng-container>
            <ng-container *ngIf="print.examDiagnosisNotes">
                <h4>{{'gastro.abdomen.Findings' | translate}}</h4>
                <div style="white-space: pre-wrap;" dir="auto">{{ print.examDiagnosisNotes }}</div>
            </ng-container>
        </section>

        <!-- Summary -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.usGeneral[0].Summary" style="white-space: normal;"></span>
            </div>
        </section>

        <!-- Recommendations -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recomm">
            <h4>{{'gastro.Recomm' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recomm}}</div>
        </section>

        <!-- Recovery / Discharge -->
        <section class="section no-page-break" *ngIf="print.usGeneral[0].Recovery">
            <h4>{{'gastro.Recovery' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Recovery}}</div>
        </section>

        <section class="section no-page-break" *ngIf="print.usGeneral[0].Dissmission">
            <h4>{{'gastro.Dissmission' | translate}}</h4>
            <div style="white-space: pre-wrap;">{{print.usGeneral[0].Dissmission}}</div>
        </section>

    </ng-container>

    <!-- Signature -->
    <ng-container *ngIf="!print.exam.Draft && print.exam.SignedBy && print.exam.SignedDate">
        <section class="section">
            <table *ngIf="print.signers">
                <tr *ngFor="let s of print.signers">
                    <td *ngIf="s.Membership == 'tech'">
                        <strong>{{'general.Tech' | translate}}: </strong> {{ s.OpenerName}}
                        <span *ngIf="s.TechNum"> <strong>{{ 'summary.doctor.licensenumber' | translate }}</strong> {{ s.TechNum }}</span>
                    </td>
                    <td *ngIf="s.Membership == 'nurse'">
                        <strong>{{ 'GUI.Patient History.Done by' | translate }}: </strong> {{ s.OpenerName }}
                        <span *ngIf="s.NurseNum"> <strong>{{ 'summary.doctor.licensenumber' | translate }}</strong> {{ s.NurseNum }}</span>
                    </td>
                </tr>
            </table>
            <div style="margin-top: 1em">
                <strong>{{'cardio.summary.signExam' | translate}}</strong>
                {{print.exam.SignedBy}}
                {{'cardio.summary.at' | translate}}
                {{print.exam.SignedDate | date:"dd.MM.yyyy HH:mm"}}
                <ng-container *ngIf="print.exam.license">
                    <strong>מ.ר.</strong>
                    {{ print.exam.license }}
                </ng-container>
                <ng-container *ngIf="print.exam.ExpertNum">
                    <strong>מ.ר.מ.</strong>
                    {{ print.exam.ExpertNum }}
                </ng-container>
            </div>
        </section>
    </ng-container>

        <div *ngIf="hasImages && print.images.length > 0" class="signatures" [ngClass]="'perpage'+imPerPage">
            <ng-container *ngFor="let image of print.images">
                <div style="width: fit-content;display: inline-flex;flex-direction: column;">
                    <img style="padding: 0.5em;" [src]="'/api/getmedia/'+image.src+'/n'">
                    <p *ngIf="image.text" class="section" style="width: 95%;margin-inline-start: 0.5em;" [ngClass]="imPerPage ==2 ? 'w100' :'w95'">{{image.text}}</p>
                </div>
            </ng-container>
        </div>
        <span class="comment" class="finished" *ngIf="loaded"></span>
    </main>
</div>
